import React, {FC} from 'react';

import QuestionCurrency from '../../components/QuestionCurrency';

import styles from './styles.module.scss';

const StepInvestment: FC = () => (
  <div className={styles.stepInvestment}>
    <QuestionCurrency
      field="nonRetirementInvestments"
      label="Non-retirement investments (Optional)"
      hintText="Brokerage accounts, stocks, ETFs, not inside a 401k or IRA."
    />
    <QuestionCurrency
      field="retirementAccounts"
      label="Retirement accounts (Optional)"
      hintText="401k, IRA, Roth IRA, pension, any tax-advantaged account."
    />
  </div>
);

export default StepInvestment;
